<template>
  <div class="flex flex-col bg-gray-100 w-full mx-auto min-h-screen items-center justify-between">
    <main class="flex flex-row items-center w-full">
      <slot></slot>
    </main>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less"></style>
